import ModalEditTable from '../CRUDUtils/ModalEditTable';
import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';


export default function EmailChainPage() {

  const [customers, setCustomers] = useState([]);
  const [reloadTimestamp, setReloadTimestamp] = useState(0)

  const params = new URLSearchParams();
  customers.forEach((id) => params.append("customer_id", id));

  const optionsEndpoint = `/read/users?${params.toString()}`;

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name)
    },
    // {
    //   title: 'Customer',
    //   dataIndex: ['customer', 'name'],
    //   key: 'customer_name',

    //   sorter: (a, b) => a.customer.name.localeCompare(b.customer.name)
    // }
  ];

  const formFields = [
    {
      name: 'email_chain_id',
      label: 'Email Chain ID',
      type: 'textarea',
      placeholder: 'Email Chain ID',
      disabled: true
    },
    {
      name: 'name',
      label: 'Name',
      type: 'textarea',
      placeholder: 'Email Chain Name',
      rules: [{ required: true, message: 'Must Enter an Email Chain Name!' }]
    },
    {
      mode: "multiple",
      allowClear: true,
      name: 'user_ids',
      label: 'Users',
      type: 'select',
      optionsEndpoint: optionsEndpoint,//`/read/users?customer_id=${customers}`,
      optionsLabel: ['email'], // Multiple fields!
      labelSeparator: ' - ',  // Optional, defaults to ' - '
      optionsValue: 'user_id',
      searchable: true,
      rules: [{ required: true, message: 'Must select at least one user!' }],
    },
    {
      mode: "multiple",
      allowClear: true,
      name: 'customer_ids',
      label: 'Customers',
      type: 'select',
      optionsEndpoint: '/read/customers',
      optionsLabel: ['name'], // Multiple fields!
      labelSeparator: ' - ',  // Optional, defaults to ' - '
      onChange: (value) => {
        setCustomers(value), 
        setReloadTimestamp(Date.now())
      },
      optionsValue: 'customer_id',
      searchable: true,
      rules: [{ required: true, message: 'Must select at least one customer type!' }],
    },
  ];

  return (
    <div className='container-wrapper'>
      <ModalEditTable
        createEndpoint="create/email_chains"
        readEndpoint="read/email_chains"
        editEndpoint="update/email_chains"
        deleteEndpoint="delete/email_chains"
        copyEndpoint="copy/email_chains"
        addedDataColumn='WebCustomers'
        addedDataColumnLabel='Customers'
        addedDataColumnName='name'
        columns={columns}
        formFields={formFields}
        canCopy={true}
        title="Email Chains"
        reloadTimestamp={reloadTimestamp}
      />
    </div>
  );
}